import { pluginFactory } from '@atlaskit/editor-common/utils';
import type { ReadonlyTransaction } from '@atlaskit/editor-prosemirror/state';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import { inEditorStreamingPluginKey } from './in-editor-streaming-plugin-key';
import type { InEditorStreamingPluginState } from './reducer';
import { reducer } from './reducer';

function mapping(
	tr: ReadonlyTransaction,
	pluginState: InEditorStreamingPluginState,
): InEditorStreamingPluginState {
	const { decorationSet } = pluginState;

	return {
		...pluginState,
		decorationSet: decorationSet.map(tr.mapping, tr.doc),
	};
}

export const createInitialState = () => {
	return {
		decorationSet: DecorationSet.empty,
	};
};

export const { createPluginState, createCommand, getPluginState } = pluginFactory(
	inEditorStreamingPluginKey,
	reducer,
	{
		mapping,
	},
);
